<ul class="steps">
  <li class="step" *ngFor="let step of steps" [ngClass]="{'step-active': step.active, 'step-error': step.error, 'step-success': step.success }">
    <div class="step-content" *ngIf="step.display">
      <span class="step-circle" *ngIf="!step.success">{{ step.label }}</span>
      <span class="step-circle" *ngIf="step.success"><fa-icon [icon]="['fas', 'check']"></fa-icon></span>
    </div>
  </li>
</ul>
